(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const picker = section.querySelector('[data-variant-select]');
      if (!picker) return;
      const rulesNode = section.parentElement.querySelector('[data-variant-rules]');
      let rules = [];
      try { rules = JSON.parse(rulesNode?.textContent || '{"variants":[]}').variants; } catch (_) {}
      picker.addEventListener('change', () => {
        const selected = picker.selectedOptions[0];
        if (!selected) return;
        section.querySelector('[data-price]').textContent = selected.dataset.price;
        const compare = section.querySelector('[data-compare]');
        compare.textContent = selected.dataset.compare || '';
        compare.hidden = selected.dataset.onSale !== 'true';
        const unit = section.querySelector('[data-unit-price]');
        unit.textContent = selected.dataset.unit || '';
        unit.hidden = !selected.dataset.unit;
        const available = selected.dataset.available === 'true';
        const add = section.querySelector('[data-add-button]');
        add.disabled = !available;
        add.textContent = available ? 'Add to bag' : 'Sold out';
        const quantity = section.querySelector('[name="quantity"]');
        const rule = rules.find(v => String(v.id) === picker.value);
        if (rule && quantity) {
          quantity.min = rule.min;
          quantity.step = rule.step;
          if (rule.max != null) quantity.max = rule.max; else quantity.removeAttribute('max');
          quantity.value = rule.min;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', picker.value);
        window.history.replaceState({}, '', url);
        const media = Array.from(section.querySelectorAll('[data-media-id]')).find(el => el.dataset.mediaId === selected.dataset.media);
        if (media) {
          const gallery = section.querySelector('.product-gallery');
          if (window.matchMedia('(max-width:749px)').matches) gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: 'auto' });
          else gallery.prepend(media);
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open],.filter-group[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open],.filter-group[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
})();

// Country/province controls for Shopify legacy address forms.
(() => {
  document.querySelectorAll('[data-country]').forEach(country => {
    const province = document.getElementById(country.dataset.provinceId);
    if (!province) return;
    const target = country.dataset.default;
    Array.from(country.options).forEach(o => { if (o.value === target || o.textContent === target) o.selected = true; });
    function update() {
      const selected = country.selectedOptions[0];
      let values = [];
      try { values = JSON.parse(selected?.dataset.provinces || '[]'); } catch (_) {}
      province.replaceChildren();
      values.forEach(([value, title]) => {
        const option = new Option(title, value, false, value === province.dataset.default || title === province.dataset.default);
        province.add(option);
      });
      province.closest('[data-province-wrapper]').hidden = !values.length;
    }
    update(); country.addEventListener('change', update);
  });
  document.querySelectorAll('.address-delete').forEach(form => form.addEventListener('submit', event => {
    if (!window.confirm('Delete this address?')) event.preventDefault();
  }));
})();
